import type {V2FormRequest} from '@yandex-delivery/types/schemas/services/delivery-corp-account-api/definitions/delivery_form'

import {orderPath} from 'src/shared/utils'

import {appConfig} from '../../../../shared/config'
import {getCoordinates} from './utils/getCoordinates'

export const Names = {
  VERTICALS: orderPath('offerFlow'),
  BUSINESS_TOGGLE: orderPath('isBusiness'),
  DESTINATION_POINT_NDD: orderPath('destinationPoints.0'),
  DESTINATION_POINTS: orderPath('destinationPoints'),
  PARCEL: orderPath('destinationPoints.0.parcels.0'),
  OFFERS: orderPath('offerFlow'),
  PAYMENT_METHOD: orderPath('paymentMethod'),
  PAYMENT_INFO: orderPath('paymentInfo'),
  NDD_ROUTE: orderPath('ndd.route'),
} as const

export const initialRequest: Omit<V2FormRequest, 'mode'> = {
  state: {
    taxi_class: 'cargo',
    offer_name: 'cargo', // пока прокси умеет только в карго, дальше будем получать из InitialParams или ставить первый из офферов из первой вертикали
    payment_info: {
      type: 'cargocorp', // нужно для первичного запроса
    },
    route: [
      {
        coordinates: getCoordinates('source'),
        type: 'source',
      },
    ],
    route_points: [],
    items: [], // без этого поля упадет ручка формы на первом запросе
  },
  user_info: {
    location: appConfig.location,
  },
}
